import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

const DeleteDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  entryToDelete 
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="delete-dialog-title"
    aria-describedby="delete-dialog-description"
  >
    <DialogTitle id="delete-dialog-title">
      Confirm Delete
    </DialogTitle>
    
    <DialogContent>
      <DialogContentText id="delete-dialog-description">
        Are you sure you want to delete the file{' '}
        <Typography component="span" fontWeight="bold">
          "{entryToDelete?.name}"
        </Typography>
        ? This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteDialog;
